var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "g-searchspring__listing g-product-list",
      attrs: { id: "js-product-list" },
    },
    [
      _vm.pagination.totalResults > 0
        ? _c(
            "div",
            {
              staticClass:
                "g-layout u-grids-2 u-grids-3--m u-grids-4--l u-grids-5--xxxl g-product-list--searchspring",
            },
            [
              _vm._l(_vm.results, function (result, index) {
                return [
                  result.isInlineBanner
                    ? _c("inline-banner", {
                        key: index,
                        attrs: { result: result },
                      })
                    : _c("product-card", {
                        key: index,
                        attrs: { result: result },
                      }),
                ]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.pagination.totalResults === 0 ? _c("div", [_vm._m(0)]) : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "u-text-center" }, [
      _c("br"),
      _vm._v(" "),
      _c("span", { staticClass: "g-heading-style-5 u-font-weight--semibold" }, [
        _vm._v("No Results."),
      ]),
      _vm._v(" "),
      _c("br"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }